import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Plus, Trash } from "@phosphor-icons/react";
import api from "@/lib/api";

const CELL = "rounded border border-border bg-background px-2 py-1 text-xs";

function Row({ t, onSave, onDelete }) {
  const [r, setR] = useState(t);
  const set = (k) => (e) => setR((p) => ({ ...p, [k]: k === "price_per_person_per_night" ? parseFloat(e.target.value) || 0 : e.target.value }));
  const blur = () => { if (JSON.stringify(r) !== JSON.stringify(t)) onSave(r); };
  return (
    <tr className="border-t border-border" data-testid={`tourist-row-${t.id}`}>
      <td className="p-2"><input value={r.name} onChange={set("name")} onBlur={blur} className={`${CELL} w-full`} /></td>
      <td className="p-2"><input type="date" value={r.start_date} onChange={set("start_date")} onBlur={blur} className={CELL} /></td>
      <td className="p-2"><input type="date" value={r.end_date} onChange={set("end_date")} onBlur={blur} className={CELL} /></td>
      <td className="p-2 text-right"><input type="number" step="0.01" value={r.price_per_person_per_night} onChange={set("price_per_person_per_night")} onBlur={blur} className={`${CELL} w-20 text-right`} /></td>
      <td className="p-2"><button onClick={() => onDelete(t.id)} className="text-muted-foreground hover:text-rose-500"><Trash size={14} /></button></td>
    </tr>
  );
}

/** Fakturiranje → Boravišna pristojba (used for the separate invoice line of pravne osobe). */
export default function TouristTaxTab() {
  const [rows, setRows] = useState([]);
  useEffect(() => { api.get("/tourist-tax-periods").then(({ data }) => setRows(data || [])); }, []);
  const add = async () => {
    const y = new Date().getFullYear();
    const { data } = await api.post("/tourist-tax-periods", { name: "Nova sezona", start_date: `${y}-04-01`, end_date: `${y}-09-30`, price_per_person_per_night: 1.6 });
    setRows((p) => [...p, data]);
  };
  const save = async (r) => {
    try {
      const { name, start_date, end_date, price_per_person_per_night, active } = r;
      const { data } = await api.put(`/tourist-tax-periods/${r.id}`, { name, start_date, end_date, price_per_person_per_night, active: active !== false });
      setRows((p) => p.map((x) => (x.id === r.id ? data : x))); toast.success("Spremljeno");
    } catch { toast.error("Greška pri spremanju"); }
  };
  const del = async (id) => { await api.delete(`/tourist-tax-periods/${id}`); setRows((p) => p.filter((x) => x.id !== id)); };
  return (
    <div className="space-y-3" data-testid="tourist-tax-tab">
      <p className="text-xs text-muted-foreground">Iznos po osobi i noćenju. Koristi se za zasebnu stavku boravišne pristojbe na računima profila „Pravna osoba” (djeca 12–17 g. plaćaju 50 %, mlađa od 12 ne plaćaju).</p>
      <div className="overflow-x-auto rounded-lg border border-border bg-card">
        <table className="w-full text-xs">
          <thead className="text-muted-foreground"><tr><th className="p-2 text-left">Naziv</th><th className="p-2 text-left">Od</th><th className="p-2 text-left">Do</th><th className="p-2 text-right">€/osoba/noć</th><th /></tr></thead>
          <tbody>
            {rows.map((t) => <Row key={t.id} t={t} onSave={save} onDelete={del} />)}
            {rows.length === 0 && <tr><td colSpan="5" className="p-4 text-center text-muted-foreground">Nema definiranih sezona</td></tr>}
          </tbody>
        </table>
      </div>
      <button onClick={add} className="flex items-center gap-1 rounded-md bg-primary px-3 py-1.5 text-xs font-semibold text-primary-foreground" data-testid="add-tourist-tax"><Plus size={12} weight="bold" /> Dodaj sezonu</button>
    </div>
  );
}
